import React from "react";
import PropTypes from "prop-types";
import { planDetailsType } from "custom-prop-types";
import styles from "components/settings/upgrade-downgrade-modal.scss";
import { Modal } from "components/common/modal";
import { Button } from "components/common/button";

export const UpgradeDowngradeModal = ({
  accountId,
  isUpgradeDowngradeVisible,
  isChangePlanLoading,
  onHideUpgradeDowngrade,
  onUpdatePlan,
  plan
}) => (
  <Modal
    isVisible={ isUpgradeDowngradeVisible }
    onClose={ onHideUpgradeDowngrade }
    transitionName={ "upgrade-downgrade-subscription" }
  >
    <h2>Are you sure you want to change your plan?</h2>
    <div className={ styles.controls }>
      <Button link onClick={ onHideUpgradeDowngrade }>cancel</Button>
      <Button
        loading={ isChangePlanLoading }
        onClick={ () => onUpdatePlan(accountId, plan) }
        primary
      >
        Change plan
      </Button>
    </div>
  </Modal>
);

UpgradeDowngradeModal.defaultProps = { plan: null };

UpgradeDowngradeModal.propTypes = {
  accountId: PropTypes.string.isRequired,
  isChangePlanLoading: PropTypes.bool.isRequired,
  isUpgradeDowngradeVisible: PropTypes.bool.isRequired,
  onHideUpgradeDowngrade: PropTypes.func.isRequired,
  onUpdatePlan: PropTypes.func.isRequired,
  plan: planDetailsType
};



// WEBPACK FOOTER //
// ./src/js/components/settings/upgrade-downgrade-modal.jsx